import formatDateFn from 'date-fns/format'

const formatDate = (date: Date | number, format: string): string => formatDateFn(date, format)

export default formatDate
